import { useContext } from 'react';
import { AddNotificationContext } from './AddNotificationContext';
export var useAddNotificationContext = function () {
    return useContext(AddNotificationContext);
};
//# sourceMappingURL=useAddNotificationContext.js.map